import { useMemo } from 'react';
import { useAtomValue } from 'jotai';
import { useResolverJobResultsQuery } from 'features/my-zone/support-requests/components/support-requests-modals/queries/resolver-bridge-queries';
import { mergeResultsWithMappedFileData } from 'features/my-zone/support-requests/components/support-requests-modals/utils/utils';
import { getFilterDataBySelectedStatuses } from 'features/my-zone/support-requests/components/support-requests-modals/modals/request-new-location/request-property/flow-config/support-request-results-modal/utils';
import { useTableConfig } from 'features/my-zone/support-requests/components/support-requests-modals/modals/request-new-location/request-property/flow-config/support-request-results-modal/use-table-config';

import {
    mappedFileDataStore,
    resultsTableFiltersStore,
} from 'features/my-zone/support-requests/store/property-store';

export const useSupportResultsTableData = () => {
    const mappedFileData = useAtomValue(mappedFileDataStore);
    const filters = useAtomValue(resultsTableFiltersStore);

    const { data: resolverJobResults } = useResolverJobResultsQuery();

    const { getTableRows } = useTableConfig({
        isSubmitting: false,
    });

    const dataTable = useMemo(() => {
        if (!resolverJobResults) return [];
        return getTableRows(
            mergeResultsWithMappedFileData(resolverJobResults, mappedFileData) ?? [],
        );
    }, [resolverJobResults, getTableRows, mappedFileData]);

    const dataToDisplay = useMemo(() => {
        return dataTable.filter((item) =>
            getFilterDataBySelectedStatuses(filters, item.status, item.isEdited),
        );
    }, [filters, dataTable]);

    return {
        allTableData: dataTable,
        tableDataByFilter: dataToDisplay,
    };
};
